export const INSIGHTS_TITLE = "Allergen & dietary insights";

// Short; the full title won't fit the narrow sidebar.
export const INSIGHTS_NAV_LABEL = "Insights";
